// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - weirdness going on with ecma modules / some ts stuff
import { nanoid } from 'nanoid/non-secure';

/**
 * Creates an id that is assigned to a block.
 *
 * @returns String id
 */
export const makeNodeId = (): string => nanoid(5);
